import { Box, ButtonBase, useTheme } from "@mui/material";

import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { tokens } from "../../../../../theme";
import Text from "../../../../theme/text/Text";
// import SPStockDetails from "../../SpStockDetails/SPStockDetails";
import ShDoubleTextSkeleton from "../../../../theme/skeleton/ShDoubleTextSkeleton";
import ShTextSkeleton from "../../../../theme/skeleton/ShTextSkeleton";
// import SpLocationDetails from "../../SpLocationDetails/SpLocationDetails";
import ButtonGroup from "../../../../../components/theme/buttons/ButtonGroup";

import PrintIcon from '@mui/icons-material/Print';
import { useGetPickingJobPickingListPDFMutation, useGetPickingLinesQuery, useUnblockStepMutation, useUpdatePickingJobStepPickingLineMutation } from "../../../../../newapi/pickingjob/pickingjobSlice";
import { showToastMessageRequestError, showToastMessageUpdateRequest } from "../../../../../utils/toasts";
import { WarehousePickingLinesInBatchesCard } from "../../../../global/cards/orders/PickingLinesCard";
import Shbutton from "../../../../theme/buttons/Shbutton";
import ShDataGrid2 from "../../../../theme/datagrid2/ShDataGrid2";
import { InputDropdown } from "../../../../theme/dropdowns/InputDropdown";
import SidepanelLoader from "../../../../theme/sidepanel2/SidepanelLoader";
import ShLabel from "../../../../theme/label/ShLabel";
import { getPickingJobStateData, getPickingJobStepData } from "../../../../../utils/labelColorText";
import { general_states } from "../../../../../utils/staticEnums";
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

const SpStockDetails = SidepanelLoader(() => import("../../SpStockDetails/SPStockDetails"));
const SpLocationDetails = SidepanelLoader(() => import("../../SpLocationDetails/SpLocationDetails"));

const GridActions = (props) => {
    const theme = useTheme();
    const {t} = useTranslation();

    const [GetPickingJobPickingListPDF,{isLoading:isFetchingPdf}] = useGetPickingJobPickingListPDFMutation();


    const handleButtonClick = async () => {
        if(isFetchingPdf) return;
        try {
            const response = await GetPickingJobPickingListPDF(props.data.pickingJob.id).unwrap();
            const newWindow = window.open(response.data, '_blank', 'noopener,noreferrer');
            if (newWindow) {
                setTimeout(() => {
                    window.URL.revokeObjectURL(response.data);
                }, 500);
            } else {
                window.URL.revokeObjectURL(response.data);
            }
        } catch (err) {
            showToastMessageUpdateRequest(t, {success: false, error: err.error});
        } 
    };
    
    return (
        <Box display="flex" alignItems="center" justifyContent="space-between" flex={1} gap={2}>
            <ButtonGroup version={2}>
                <Shbutton
                    className={"group-btn"}
                    onClick={handleButtonClick}
                    color={theme.palette.mode === "dark" ? "blue" : "primary"}
                    variant="contained"
                    endIcon={<PrintIcon />}
                    disabled={isFetchingPdf}
                    isLoading={isFetchingPdf}
                >
                    {isFetchingPdf ? t('loading') : t('print')}
                </Shbutton>
            </ButtonGroup>
        </Box>
    )
}

const gridOptions = {
    export:true,
    disableCustomActionsOnPhone: true,
    isSidepanel: true,
    

};

const PickingLines = (props) => {
    const {t} = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode); 
    const [isExtended, setIsExtended] = useState(false);
    const [spStockLoading, setSpStockLoading] = useState(false);
    const spStockLoadingRef = useRef(spStockLoading);

    const [unBlockStep, {isLoading}]= useUnblockStepMutation();
    const [locationIsExtended, setLocationIsExtended] = useState(false);
    const [spLocationLoading, setSpLocationLoading] = useState(false);

    useEffect(() => {
        props.replaceView({
            ...props.config,
            // mobileActions: <GridActions data={props.data} />,
            gridOptions:gridOptions
        });

        return () => {
            // console.log("unmounting warehouse");
        }
    },[props.data]);

    

    const [locationId, setLocationId] = useState();
    const locationIdRef = useRef(locationId);

    const [productId, setProductId] = useState();
    const productIdRef = useRef(productId);
    
    
    const getLocationDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.warehouseLocationId);
        // Only update state if the productId has actually changed
        if (locationIdRef.current !== newProductId) {
            if(!spLocationLoading){
                setSpLocationLoading(true);
            } 
            setLocationId(newProductId);
            locationIdRef.current = newProductId; // Update the ref to the new value
        }
            setLocationIsExtended(true);
    };
    
    const getProductDetails = (params) => {
        if (!params) return;
    
        const newProductId = parseInt(params.row.productId);
        // Only update state if the productId has actually changed
        if (productIdRef.current !== newProductId) {

            if (!spStockLoadingRef.current) {
                setSpStockLoading(true);
            }
            setProductId(newProductId);
            productIdRef.current = newProductId; // Update the ref to the new value
        }
            setIsExtended(true);
    };
    useEffect(() => {
        spStockLoadingRef.current = spStockLoading; // Sync state with the ref
    }, [spStockLoading]);
    

    const [EditPickingLine, {pickingLineIsLoading}] = useUpdatePickingJobStepPickingLineMutation();
    const handlePickingLineLocationUpdate = async (params, stockObj) => {
        try {
            const response = await EditPickingLine({id: params.id, properties: { stockId: stockObj.id }, type: "location"}).unwrap();
            showToastMessageUpdateRequest(t, response);
        } catch (err) {
            console.log(err);
            showToastMessageUpdateRequest(t, {success: false, error: err.error});
        }
    };

    const columns = [
        {
            field: "location", 
            headerName: t('location'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return (
                    <Box>
                        <Text clickable semibold variant={theme.palette.mode === "dark" ? "blue" : "primary"}>
                            {params.row.location}
                        </Text>
                    </Box>
                )
            }
        },
        {
            field: "sku", 
            headerName: t('product'),
            flex:1.5, 
            cellClassName: "sku-cell", 
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShDoubleTextSkeleton/>
                }
                return (
                    <Box 
                        paddingLeft={0} 
                        onClick={(event) => {
                            console.log(spStockLoading);
                            event.stopPropagation();
                            getProductDetails(params);
                            // alert("executed")
                        }}
                    >
                        <Text bold clickable={true} variant={theme.palette.mode === "dark" ? "blue" : "primary"}>{params.row.barcode}</Text><br/>
                        <Text clickable={true}>{params.row.description}</Text>
                    </Box>
                )
            }
        },
        {
            field: "amount", 
            headerName: t('amount'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }
                return params.row.amount
            }
        },
        {
            field: "state", 
            headerName: t('state'),
            flex:1,
            renderCell : (params) => {
                if(params.row.skeleton) {
                    return <ShTextSkeleton/>
                }

                const {labelcolor, labeltext} = getPickingJobStepData(params.row.state,theme);
                if(params.row.state === general_states.BLOCKED) {
                    return (
                        <Box
                            sx={{
                                display:"flex",
                                gap:1,
                                alignItems:'center',
                            }}
                        >
                            <ShLabel 
                                borderless
                                size={32}
                                fitted
                                variant={labelcolor}
                                palette="normal"
                            >
                                {t(labeltext)}
                            </ShLabel>

                            <ButtonBase
                                onClick={async (e) => {
                                    e.stopPropagation();
                                    if(isLoading) return;
                                    try {
                                        const response = await unBlockStep(params.row.id).unwrap();
                                        showToastMessageUpdateRequest(t, response);
                                    } catch (err) {
                                        showToastMessageRequestError(t("update_failed"), t, err);
                                    }
                                }}
                                sx={{
                                    height:32,
                                    width:32,
                                    color:theme.palette.mode === "dark" ? colors.blue[400] : colors.primary[400],
                                    display:"flex",
                                    alignItems:'center',
                                    justifyContent:"center",
                                    borderRadius:4,
                                    "&:hover" : {
                                        background:theme.palette.mode === "dark" ? colors.blue[100] : colors.primary[100]
                                    }
                                }}
                            >
                                <Inventory2OutlinedIcon fontSize="small"/>
                            </ButtonBase>

                        </Box>
                    )
                } else {
                    
                    return (
                        <ShLabel 
                            borderless
                            size={32}
                            fitted
                            variant={labelcolor}
                            palette="normal"
                        >
                            {t(labeltext)}
                        </ShLabel>
                    );
                }
                // return ()
            }
        },
        {
            field: "phoneView", 
            headerName: "PhoneView",
            cellClassName: "phone-column--cell",
            // hide: true,
            renderCell: (params) => {
                // console.log(cellValues.row);
                return (

                    <WarehousePickingLinesInBatchesCard
                        onClick={() => getProductDetails(params.row)} 
                        skeleton={params.row.skeleton ?? false} params={params} 
                        // handlePickingLineLocationUpdate={handlePickingLineLocationUpdate}
                        getLocationDetails={getLocationDetails}
                        getProductDetails={getProductDetails}
                    />
                    // <WarehouseLocationCard onClick={() => getLocationDetails(params)} skeleton={params.row.skeleton ?? false} {...params.row}/>
                    // <Box
                    //     sx={{
                    //         background:`${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[100]}`,
                    //         paddingX:2,
                    //         paddingY:1.5,
                    //         borderRadius:2
                    //     }}
                    // >

                    // </Box>
                )
            }
        }
    ];
    return (
        <Box height={1} display={"flex"} flexDirection={"column"}
            sx={{
                "& .sku-cell" : {
                    paddingLeft:0,
                },
                "& [aria-label='SKU']" : {
                    paddingLeft:0,
                },
            }}
        >
            {/* <GridActions></GridActions> */}
            {props.data &&
                <ShDataGrid2 
                    key={theme.palette.mode} 
                    content={useGetPickingLinesQuery}
                    itemId={props.data?.pickingJob?.id}
                    // gridActions={<GridActions data={props.data}></GridActions>} 
                    title={t('pickinglines')}
                    gridOptions={gridOptions}
                    isSidepanelGrid={true}
                    columns={columns} 
                    // rows={props.data.pickingLines}
                    onRowClick={getLocationDetails}
                />
            }

            {spStockLoading && 
                <SpStockDetails
                    isExtended={isExtended}
                    setIsExtended={setIsExtended}
                    productId={productId}
                />
            }
            
            {spLocationLoading && 
                <SpLocationDetails
                    isExtended={locationIsExtended}
                    setIsExtended={setLocationIsExtended}
                    locationId={locationId}
                />
            }

        </Box>
    );
}

export default PickingLines;